export const DARK_GREY_COLOR = '#6b7983'
export const INACTIVE_GREY_COLOR = '#92969c'
export const DISABLED_GREY_COLOR = '#c8cccf'
export const LIGHT_GREY_COLOR = '#eef2f5'
export const WHITE_COLOR = '#ffffff'
